import vars from '../helpers';
import navInit from './nav';
import sliderInit from './slider';
// import formInit from './form';

const KEY_SPACE = 32;
const KEY_HOME = 36;
const KEY_END = 35;
const KEY_PAGE_UP = 33;
const KEY_PAGE_DOWN = 34;
const KEY_ARROW_TOP = 38;
const KEY_ARROW_BOTTOM = 40;

const navLink = document.querySelectorAll('.nav__link, .header__link');
const screenSection = document.querySelectorAll('[data-screen]');
let isAnimate = true;
let isResize = true;
let screenTl = gsap.timeline();
let screenFadeGlichTl = gsap.timeline();
let animateTextTl = gsap.timeline();
let keyPressNext = [KEY_SPACE, KEY_PAGE_DOWN, KEY_ARROW_BOTTOM];
let keyPressPrev = [KEY_PAGE_UP, KEY_ARROW_TOP];

const getRandomInt = (min, max) => {
	return Math.floor(Math.random() * (max + 1 - min) + min);
};

const screenAnimateFadeGlich = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	screenFadeGlichTl
		.to(element, {
			onComplete() {
				element.classList.add('is-animate');
			},
			duration: getRandomInt(1, 2) / 10,
			opacity: 0,
			ease: 'Power1.easeOut',
			clearProps: 'all',
		}, '>');
};

const screenAnimateLeftGlich = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: getRandomInt(3, 19) / 10,
		scaleX: 1,
		svgOrigin: '0 720',
		ease: 'Power3.easeOut',
	}, '<');
};

const screenAnimateRightGlich = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: getRandomInt(3, 19) / 10,
		scaleX: 1,
		svgOrigin: '1440 720',
		transformOrigin: '1440 0',
		ease: 'Power3.easeOut',
	}, '<');
};

const screenAnimateFadeUp = (element) => {
	if (element.classList.contains('is-animate') || vars.isMobile() && element.dataset.screenAnimateDisabled === 'mobile') {
		return;
	}

	const elDelay = element.dataset.screenAnimateDelay ? element.dataset.screenAnimateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: 0.3,
		y: 0,
		opacity: 1,
		delay: vars.isDesktop() ? elDelay : 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const screenAnimateText = (element) => {
	let elTitle = element.dataset.title;

	animateTextTl
		.to(element, {
			delay: 0.3,
			duration: 0.4,
			text: elTitle,
			ease: 'none',
		}, '<');
};

const screenFilter = (screen) => {
	let animateLeftGlich = screen.querySelectorAll('[data-screen-animate="left-glich"]');
	let animateRightGlich = screen.querySelectorAll('[data-screen-animate="right-glich"]');
	const animateButton = screen.querySelector('.button');
	const animateNav = screen.querySelector('.nav');
	let screenAnimate = screen.dataset.screenAnimate;

	if (vars.isMobile()) {
		animateLeftGlich = screen.querySelectorAll('[data-screen-animate-mobile="left-glich"]');
		animateRightGlich = screen.querySelectorAll('[data-screen-animate-mobile="right-glich"]');
	}

	if (vars.isTablet()) {
		animateLeftGlich = screen.querySelectorAll('[data-screen-animate-tablet="left-glich"]');
		animateRightGlich = screen.querySelectorAll('[data-screen-animate-tablet="right-glich"]');
	}

	if (screenAnimate === 'intro' || screenAnimate === 'traffic') {
		let animateFadeGlich = screen.querySelectorAll('[data-screen-animate="fade-glich"]');

		if (vars.isMobile()) {
			animateFadeGlich = screen.querySelectorAll('[data-screen-animate-mobile="fade-glich"]');
		}

		if (vars.isTablet()) {
			animateFadeGlich = screen.querySelectorAll('[data-screen-animate-tablet="fade-glich"]');
		}

		animateFadeGlich.forEach((el) => {
			const animateOrder = el.dataset.screenAnimateOrder * 10;

			setTimeout(() => {
				screenAnimateFadeGlich(el);
			}, animateOrder || 10);
		});

		screen.dataset.screenAnimate = 'done';
	}

	if (screenAnimate === 'dating' || screenAnimate === 'format' || screenAnimate === 'geo' || screenAnimate === 'partner' || screenAnimate === 'event') {
		if (vars.isDesktop() || !isAnimate) {
			const animateFadeUp = screen.querySelectorAll('[data-screen-animate="fade-up"]');

			animateFadeUp.forEach((el) => {
				screenAnimateFadeUp(el);
			});
		}

		screen.dataset.screenAnimate = 'done';
	}

	if (animateLeftGlich && screenAnimate !== 'done') {
		animateLeftGlich.forEach((el) => {
			screenAnimateLeftGlich(el);
		});
	}

	if (animateRightGlich && screenAnimate !== 'done') {
		animateRightGlich.forEach((el) => {
			screenAnimateRightGlich(el);
		});
	}

	if (animateButton && !animateButton.classList.contains('is-animate')) {
		animateButton.classList.add('is-animate');
	}

	if (animateNav && !animateNav.classList.contains('is-animate') && vars.isDesktop()) {
		animateNav.classList.add('is-animate');
	}
};

const screenTransition = (current) => {
	let sectionCurrent = document.querySelector('[data-screen="current"]');
	let sectionNext = document.querySelector(current);
	let sectionNextCurrent;

	screenTl
		.to(window, {
			onStart() {
				window.location.hash = current !== '#intro' && vars.isDesktop() ? current : '';
				sectionCurrent.dataset.screen = '';
				sectionNext.dataset.screen = 'current';

				gsap.delayedCall(0.2, () => {
					sectionNextCurrent = document.querySelector('[data-screen="current"]');
					screenFilter(sectionNextCurrent);
				});

				if (sectionCurrent.querySelector('.nav')) {
					sectionCurrent.querySelector('.nav').classList.remove('is-animate');
				}
			},
			onComplete() {
				// sectionNextCurrent = document.querySelector('[data-screen="current"]');

				gsap.delayedCall(0.1, () => {
					isAnimate = true;
				});

				// screenFilter(sectionNextCurrent);

				if (sectionNextCurrent.querySelector('.button')) {
					sectionNextCurrent.querySelector('.button').classList.add('is-animate');
				}
			},
			duration: 0.5,
			scrollTo: current,
			ease: 'Power3.easeOut',
		});
};

const screenInit = () => {
	navInit();
	sliderInit();

	navLink.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			isAnimate = false;
			screenTransition(e.target.dataset.href);
		});
	});

	document.addEventListener('DOMContentLoaded', () => {
		let hash = window.location.hash;

		if (hash && document.querySelector(hash)) {
			window.location.hash = '';
			screenTransition(hash);
		} else if (hash && !document.querySelector(hash) || !hash) {
			const section = document.querySelector('[data-screen="current"]');

			screenFilter(section);
		}
	});

	if (vars.isDesktop()) {
		window.addEventListener('wheel', (e) => {
			const delta = e.deltaY || e.detail || e.wheelDelta;
			const section = document.querySelector('[data-screen="current"]');
			const sectionPrev = section.dataset.screenPrev;
			const sectionNext = section.dataset.screenNext;

			if (delta > 30 && isAnimate && sectionNext !== 'last') {
				isAnimate = false;
				screenTransition(sectionNext);
			} else if (delta < -30 && isAnimate && sectionPrev !== 'first') {
				isAnimate = false;
				screenTransition(sectionPrev);
			}
		});

		window.addEventListener('keydown', (e) => {
			const section = document.querySelector('[data-screen="current"]');
			const sectionPrev = section.dataset.screenPrev;
			const sectionNext = section.dataset.screenNext;

			if (e.keyCode && keyPressNext.indexOf(e.keyCode) !== -1 && isAnimate && sectionNext !== 'last') {
				isAnimate = false;
				screenTransition(sectionNext);
			} else if (e.keyCode && keyPressPrev.indexOf(e.keyCode) !== -1 && isAnimate && sectionPrev !== 'first') {
				isAnimate = false;
				screenTransition(sectionPrev);
			}
		});

		window.addEventListener('resize', () => {
			if (isResize) {
				isResize = false;

				setTimeout(() => {
					const section = document.querySelector('[data-screen="current"]');
					isResize = true;
					screenTransition(`#${section.id}`);
				}, 3000);
			}
		});
	}

	if (!vars.isDesktop()) {
		const partherItem = document.querySelectorAll('.partner__item');
		const animateFadeUp = document.querySelectorAll('[data-screen-animate="fade-up"]');

		partherItem.forEach((item) => {
			item.addEventListener('click', () => {
				gsap.delayedCall(0.1, () => {
					item.classList.toggle('is-active');
				});
			});
		});

		document.addEventListener('click', (e) => {
			const targetTtem = e.target.closest('.partner__item');

			if (targetTtem === null && document.querySelector('.partner__item.is-active')) {
				document.querySelector('.partner__item.is-active').classList.remove('is-active');
			}

			if (targetTtem && !targetTtem.classList.contains('is-active') && document.querySelector('.partner__item.is-active')) {
				document.querySelector('.partner__item.is-active').classList.remove('is-active');
			}
		});

		const observers = new IntersectionObserver((entries, observer) => {
			entries.forEach((section) => {
				if (section.isIntersecting && isAnimate) {
					observer.unobserve(section.target);

					if (section.target.dataset.screenAnimate === 'fade-up') {
						screenAnimateFadeUp(section.target);
					} else {
						screenFilter(section.target);
					}
				}
			});
		}, {threshold: 0.3});

		screenSection.forEach((section) => {
			observers.observe(section);
		});

		animateFadeUp.forEach((section) => {
			observers.observe(section);
		});
	}
};

if (vars.html.classList.contains('page-home')) {
	screenInit();
}
if (vars.html.classList.contains('page-staff')) {
	document.querySelector('.button').classList.add('is-animate');
}

if (vars.html.classList.contains('page-faq')) {
	const faqQuestion = document.querySelectorAll('.article__question');

	faqQuestion.forEach((question) => {
		question.addEventListener('click', () => {
			const questionParrent = question.closest('.article__question-wrap');

			if (questionParrent.classList.contains('is-active')) {
				questionParrent.classList.remove('is-active');
			} else if (document.querySelector('.article__question-wrap.is-active')) {
				document.querySelector('.article__question-wrap.is-active').classList.remove('is-active');
				questionParrent.classList.add('is-active');
			} else {
				questionParrent.classList.add('is-active');
			}
		});
	});

	screenFilter(document.querySelector('.article--faq'));
}

if (vars.html.classList.contains('page-about')) {
	screenFilter(document.querySelector('.article--about'));
}
